import { Component } from '@angular/core';
import { LoadingSpinnerComponent } from '@zeiss/beyond-online-angular';

@Component({
	selector: 'app-loading-animation-directive-container',
	templateUrl: './loading-animation-directive-container.component.html',
	imports: [LoadingSpinnerComponent],
})
export class LoadingAnimationDirectiveContainerComponent {}
